export default __webpack_public_path__ + "static/media/festivities.3c91a86c.jpg";